import React, { useRef, useLayoutEffect, useState } from 'react';
import { useMedia } from 'react-use';
import {
  AboutContainer,
  AboutContentRow,
  AboutLaunchContainer,
  AboutMonth,
  AboutSubTitle,
  AboutTitle,
  AboutYear,
  AboutLaunchTitle,
} from './style';
import TimeLineItem from '../../components/timeLineItem';
import Line, { DIRECTION } from '../../components/line';
import DecorationContainer from '../../components/decorationContainer';
import Decoration from '../../components/decoration';
import Ellipse4 from '../../assets/about_group-on-floor.png';
import Ellipse5 from '../../assets/about_tablet-holding-hand.png';
import Ellipse6 from '../../assets/about_payment-card-transaction.png';
import { fromLargeMediaQuery } from '../../constants';

const useIsMounted = () => {
  const [state, setState] = useState(false);
  useLayoutEffect(() => {
    setState(true);
  }, []);
  return state;
};

const About = () => {
  const isLarge = useMedia(fromLargeMediaQuery);

  // HACK: force re render 1 time
  // eslint-disable-next-line
  const isMounted = useIsMounted();

  const nodeNovember19Ref = useRef(null);
  const nodeNovember19 = nodeNovember19Ref?.current;
  const nodeDecember19Ref = useRef(null);
  const nodeDecember19 = nodeDecember19Ref?.current;
  const nodeFebruary20Ref = useRef(null);
  const nodeFebruary20 = nodeFebruary20Ref?.current;
  const nodeMay20Ref = useRef(null);
  const nodeMay20 = nodeMay20Ref?.current;
  const nodeSeptember20Ref = useRef(null);
  const nodeSeptember20 = nodeSeptember20Ref?.current;
  const nodeJanuary21ImgRef = useRef(null);
  const nodeJanuary21Img = nodeJanuary21ImgRef?.current;
  const nodeJanuary21Ref = useRef(null);
  const nodeJanuary21 = nodeJanuary21Ref?.current;
  const nodeFebruary21Ref = useRef(null);
  const nodeFebruary21 = nodeFebruary21Ref?.current;
  const nodeMarch21Ref = useRef(null);
  const nodeMarch21 = nodeMarch21Ref?.current;
  const nodeJuly21Ref = useRef(null);
  const nodeJuly21 = nodeJuly21Ref?.current;
  const nodeOctober21Ref = useRef(null);
  const nodeOctober21 = nodeOctober21Ref?.current;

  const nodeOctober22Ref = useRef(null);
  const nodeOctober22 = nodeOctober22Ref?.current;

  const nodeMay23Ref = useRef(null);
  const nodeMay23 = nodeMay23Ref?.current;

  const nodeLastRef = useRef(null);
  const nodeLast = nodeLastRef?.current;

  console.log(nodeJanuary21Img);

  return (
    <>
      {isLarge && (
        <>
          <DecorationContainer
            style={{
              transform: 'translateX(-100%)',
            }}
            points={[
              {
                node: nodeNovember19,
                direction: DIRECTION.BOTTOM_LEFT,
                offset: {
                  y: 2,
                  x: -52,
                },
              },
            ]}
          >
            <Decoration width={10} height={10} name="circle"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            style={{
              zIndex: 1,
            }}
            points={[
              {
                node: nodeNovember19,
                direction: DIRECTION.BOTTOM_LEFT,
                offset: {
                  y: -4.42,
                  x: 137.58,
                },
              },
            ]}
          >
            <Decoration width={11.47} height={11.47} name="cross"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            style={{
              transform: 'translateX(-100%)',
            }}
            points={[
              {
                node: nodeFebruary20,
                direction: DIRECTION.TOP_RIGHT,
                offset: {
                  y: 32,
                  x: 206,
                },
              },
            ]}
          >
            <Decoration width={17.93} height={17.93} name="cross"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            style={{
              transform: 'none',
            }}
            points={[
              {
                node: nodeMay20,
                direction: DIRECTION.TOP_RIGHT,
                offset: {
                  y: 31,
                  x: 111.52,
                },
              },
            ]}
          >
            <Decoration width={23.82} height={23.82} name="circle"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            style={{
              transform: 'translateX(-100%)',
            }}
            points={[
              {
                node: nodeMay20,
                direction: DIRECTION.TOP_LEFT,
                offset: {
                  y: 31,
                  x: -68.37,
                },
              },
            ]}
          >
            <Decoration name="dots6x3"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            style={{
              transform: 'translate(0, -100%)',
            }}
            points={[
              {
                node: nodeFebruary21,
                direction: DIRECTION.TOP_RIGHT,
                offset: {
                  y: -158.45,
                  x: 79,
                },
              },
            ]}
          >
            <Decoration name="dots6x3"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            style={{
              transform: 'translate(-100%, -100%)',
            }}
            points={[
              {
                node: nodeFebruary21,
                direction: DIRECTION.TOP_RIGHT,
                offset: {
                  y: -63.39,
                  x: -120.96,
                },
              },
            ]}
          >
            <Decoration width={17.93} height={17.93} name="cross"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            style={{
              transform: 'none',
            }}
            points={[
              {
                node: nodeFebruary21,
                direction: DIRECTION.TOP_RIGHT,
                offset: {
                  y: 22.77,
                  x: 84,
                },
              },
            ]}
          >
            <Decoration width={10} height={10} name="circle"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            style={{
              transform: 'none',
            }}
            points={[
              {
                node: nodeJanuary21Img,
                direction: DIRECTION.TOP_LEFT,
                offset: {
                  y: 56,
                  x: -26,
                },
              },
            ]}
          >
            <Decoration name="dots6x2"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            style={{
              transform: 'none',
            }}
            points={[
              {
                node: nodeJanuary21Img,
                direction: DIRECTION.TOP_LEFT,
                offset: {
                  y: 156.14,
                  x: 36,
                },
              },
            ]}
          >
            <Decoration width={17.93} height={17.93} name="cross"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            style={{
              transform: 'translateX(-100%)',
            }}
            points={[
              {
                node: nodeJuly21,
                direction: DIRECTION.TOP_LEFT,
                offset: {
                  x: -32.28,
                  y: 51,
                },
              },
            ]}
          >
            <Decoration width={17.93} height={17.93} name="circle"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            style={{
              transform: 'translate(-100%, -100%)',
            }}
            points={[
              {
                node: nodeLast,
                direction: DIRECTION.TOP_LEFT,
                offset: {
                  x: -78.19,
                  y: 0,
                },
              },
            ]}
          >
            <Decoration width={13.46} height={13.46} name="circle"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            style={{
              transform: 'none',
            }}
            points={[
              {
                node: nodeLast,
                direction: DIRECTION.TOP_RIGHT,
                offset: {
                  x: 196,
                  y: 33,
                },
              },
            ]}
          >
            <Decoration width={12.95} height={12.95} name="cross"></Decoration>
          </DecorationContainer>

          <DecorationContainer
            points={[
              {
                node: nodeDecember19,
                direction: DIRECTION.TOP_RIGHT,
                offset: {
                  y: 24,
                  x: -162,
                },
              },
              {
                node: nodeSeptember20,
                direction: DIRECTION.BOTTOM_LEFT,
                offset: {
                  y: 19.82,
                  x: 137,
                },
              },
            ]}
          >
            <Decoration name="about1"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            points={[
              {
                node: nodeJanuary21,
                direction: DIRECTION.TOP,
                offset: {
                  y: -18,
                },
              },
              {
                node: nodeFebruary21,
                direction: DIRECTION.RIGHT,
                offset: {
                  x: -113.76,
                },
              },
              {
                node: nodeMarch21,
                direction: DIRECTION.LEFT,
                offset: {
                  x: -32,
                },
              },
              {
                node: nodeJuly21,
                direction: DIRECTION.BOTTOM,
                offset: {
                  y: -14.05,
                },
              },
            ]}
          >
            <Decoration name="about2"></Decoration>
          </DecorationContainer>
          <DecorationContainer
            points={[
              {
                node: nodeLast,
                direction: DIRECTION.TOP,
                offset: {
                  y: 60,
                  x: 20,
                },
              },
            ]}
          >
            <Decoration name="about3"></Decoration>
          </DecorationContainer>
          <Line
            svgWidth={282}
            svgHeight={282}
            svgPathD="M1 266.44C12.9841 276.883 24.6988 282.03 35.9013 281.701C36.589 281.744 37.2117 281.692 37.8345 281.64C56.8565 280.059 74.1649 262.665 87.9192 231.318C98.847 206.427 107.934 175.167 116.764 144.931C129.274 102.047 142.235 57.7213 160.496 31.2173C170.159 17.1684 181.538 7.99416 194.359 3.81763C206.678 -0.216887 220.471 0.44266 235.381 5.62523C249.765 10.6508 265.371 20.0904 281.713 33.5829M1.09666 266.231C13.0158 276.579 24.7306 281.726 35.8765 281.402C55.6124 280.865 73.5435 263.419 87.8377 231.024C98.7738 206.232 107.861 174.972 116.691 144.737C129.201 101.853 142.105 57.5314 160.423 31.0226C170.086 16.9738 181.522 7.79483 194.342 3.61831C206.719 -0.420918 220.511 0.238658 235.421 5.42123C249.862 10.4421 265.468 19.8817 281.81 33.3742"
            nodeA={nodeNovember19}
            nodeB={nodeDecember19}
            nodeADirection={DIRECTION.TOP_LEFT}
            nodeBDirection={DIRECTION.TOP_RIGHT}
            containerOffset={{
              top: -56,
              bottom: 24.72,
              left: -67,
            }}
          ></Line>
          <Line
            svgWidth={360}
            svgHeight={190}
            svgPathD="M1.02961 28.8806C0.636961 44.7715 4.14986 57.0755 11.5522 65.4904C11.9578 66.0473 12.3951 66.4938 12.8324 66.9402C26.1888 80.5763 50.6258 82.8025 83.5377 73.3879C109.675 65.9172 139.541 52.9648 168.455 40.4687C209.455 22.7341 251.853 4.42581 283.912 1.57188C300.895 0.046238 315.22 2.9527 326.617 10.1584C337.585 17.0688 345.879 28.109 351.404 42.8957C356.714 57.1771 359.405 75.2161 359.446 96.4081C359.494 117.036 356.899 140.968 351.915 167.32M1.25201 28.8218C0.891039 44.6022 4.40392 56.9062 11.7666 65.2804C24.7744 80.1327 49.6487 82.8053 83.7123 73.1374C109.778 65.7367 139.645 52.7844 168.558 40.2882C209.559 22.5537 251.917 4.20472 284.016 1.39137C300.998 -0.13427 315.363 2.81274 326.76 10.0184C337.768 16.9694 346.062 28.0097 351.587 42.7963C356.936 57.1183 359.627 75.1572 359.668 96.3493C359.684 117.088 357.121 140.909 352.137 167.261C350.721 174.533 349.17 182.096 347.611 189.507"
            nodeA={nodeDecember19}
            nodeB={nodeFebruary20}
            nodeADirection={DIRECTION.TOP_RIGHT}
            nodeBDirection={DIRECTION.TOP_LEFT}
            containerOffset={{
              top: 37,
              left: -52,
              bottom: 43.51,
              right: 62.67,
            }}
          ></Line>
          <Line
            svgWidth={543}
            svgHeight={237}
            svgPathD="M542.007 37.0693C534.223 28.7389 526.391 22.4264 518.8 18.3038C511.207 14.0934 503.929 12.2475 497.181 12.6759C489.785 13.1117 483.213 16.3447 477.677 22.2847C471.929 28.4902 467.29 37.4895 464.046 49.0163C461.629 57.5516 459.802 67.3957 458.043 76.8882C455.268 91.7424 452.428 107.124 447.374 117.532C443.303 125.911 437.684 130.799 431.014 131.84C422.623 133.165 413.084 128.363 403.48 117.948C394.897 108.75 386.41 95.5159 378.215 82.6296C374.337 76.5347 370.314 70.2661 366.368 64.5228C351.753 43.2028 336.552 27.0641 321.342 16.451C307.218 6.61486 292.933 1.42897 278.775 1.06546C277.912 0.987666 277.122 0.996806 276.331 1.00589C252.194 1.28332 228.719 15.4984 208.405 42.1314C192.267 63.2787 177.847 90.1071 163.847 116.054C144.009 152.856 123.467 190.893 97.9282 213.026C84.4122 224.758 69.1933 232.125 52.63 235.034C36.7122 237.848 19.3811 236.469 1.06975 231.066M541.794 37.3349C534.012 29.0922 526.251 22.7789 518.66 18.6562C511.069 14.5336 503.863 12.6868 497.114 13.1152C489.791 13.5502 483.29 16.7824 477.753 22.6346C472.003 28.7524 467.437 37.751 464.192 49.2778C461.775 57.7254 459.948 67.5695 458.19 77.1496C455.415 92.0039 452.574 107.386 447.521 117.793C443.45 126.172 437.688 131.15 430.946 132.192C422.483 133.517 412.871 128.628 403.268 118.214C394.756 109.015 386.268 95.693 378.002 82.8074C374.124 76.7126 370.1 70.444 366.154 64.7007C351.54 43.3806 336.41 27.2411 321.2 16.6281C307.15 6.87878 292.864 1.6929 278.778 1.32857C253.839 0.650426 229.574 14.8746 208.48 42.3937C192.341 63.4533 177.921 90.2817 163.921 116.229C144.083 153.03 123.613 191.067 98.0022 213.2C84.4861 224.933 69.1954 232.3 52.632 235.21C36.6424 238.025 19.3114 236.645 1 231.242"
            nodeA={nodeFebruary20}
            nodeB={nodeMay20}
            nodeADirection={DIRECTION.TOP_LEFT}
            nodeBDirection={DIRECTION.TOP_RIGHT}
            containerOffset={{
              top: 66,
              right: 15.01,
              bottom: 70.63,
              left: -198,
            }}
          ></Line>
          <Line
            svgWidth={545}
            svgHeight={209}
            svgPathD="M1 67.6705C10.4402 85.7206 22.6276 99.2438 37.3527 107.9C38.2195 108.483 39.0577 108.937 39.8958 109.391C65.497 123.256 98.121 122.879 134.293 108.309C163.023 96.7449 193.09 78.5281 222.225 60.9412C263.529 35.9859 306.26 10.2147 345.447 3.17894C366.197 -0.563816 386.323 1.02999 405.397 7.84188C423.738 14.3701 441.245 25.8944 457.557 41.9917C473.278 57.542 488.004 77.6602 501.314 101.665C514.281 125.03 525.938 152.452 536.055 182.899C538.871 191.346 541.572 200.186 544.188 208.639M1.24744 67.5775C10.6589 85.4986 22.8464 99.0218 37.4953 107.637C63.4118 122.921 96.874 122.998 134.359 108.005C163.042 96.5282 193.109 78.3114 222.244 60.7244C263.548 35.7691 306.203 9.95674 345.466 2.96216C366.216 -0.780599 386.418 0.854483 405.492 7.66637C423.909 14.2358 441.417 25.7602 457.728 41.8575C473.526 57.4491 488.251 77.5671 501.561 101.572C514.557 125.066 526.185 152.359 536.303 182.806C539.042 191.212 541.791 199.964 544.436 208.546"
            nodeA={nodeMay20}
            nodeB={nodeSeptember20}
            nodeADirection={DIRECTION.TOP_RIGHT}
            nodeBDirection={DIRECTION.TOP_LEFT}
            containerOffset={{
              top: 54,
              left: -20,
              bottom: 99.64,
              right: 94.44,
            }}
          ></Line>
          <Line
            svgWidth={472}
            svgHeight={389}
            svgPathD="M471.668 2.98035C462.794 1.10368 454.822 0.565525 448.018 1.34585C441.172 2.06943 435.623 4.19161 431.466 7.55556C426.896 11.2198 424.149 16.3329 423.323 22.7378C422.483 29.4131 423.65 37.4036 426.885 46.4056C429.272 53.0779 432.644 60.3343 435.897 67.3304C440.974 78.2885 446.251 89.6204 447.802 98.7191C449.049 106.045 447.682 111.802 443.86 115.53C439.058 120.229 430.683 121.457 419.671 119.052C409.88 116.975 398.286 112.221 387.041 107.561C381.721 105.357 376.227 103.107 371.025 101.164C351.739 93.9365 334.469 90.3567 319.748 90.3853C306.088 90.424 294.472 93.5702 285.169 99.8041C284.576 100.148 284.07 100.515 283.564 100.882C268.117 112.095 259.542 132.096 258.746 158.754C258.109 179.925 261.207 204.017 264.168 227.341C268.381 260.414 272.71 294.616 266.463 320.726C263.165 334.557 256.751 346.318 247.408 355.786C238.437 364.897 226.617 371.918 212.303 376.763C198.486 381.421 182.126 384.026 163.754 384.538C145.87 385.044 125.842 383.466 104.367 379.993C98.4064 379.035 92.235 377.882 86.3251 376.8C62.3369 372.379 37.5135 367.871 21.0067 372.401C11.6327 374.96 4.9331 380.43 1 388.744M471.653 3.2507C462.821 1.43078 454.895 0.859247 448.091 1.63957C441.286 2.4199 435.783 4.5087 431.626 7.87266C427.102 11.5036 424.401 16.5832 423.534 22.9314C422.652 29.5499 423.865 37.5071 427.101 46.5091C429.446 53.1246 432.818 60.3811 436.113 67.4339C441.189 78.392 446.467 89.7239 448.017 98.8226C449.264 106.149 447.847 112.029 443.979 115.791C439.131 120.523 430.668 121.727 419.657 119.323C409.912 117.212 398.277 112.402 386.985 107.774C381.665 105.571 376.171 103.321 370.97 101.378C351.683 94.1501 334.46 90.537 319.739 90.5655C306.165 90.6276 294.55 93.7738 285.292 99.9743C268.886 110.93 259.805 131.299 258.916 158.891C258.237 180.005 261.335 204.097 264.297 227.421C268.509 260.494 272.885 294.663 266.591 320.806C263.293 334.637 256.833 346.432 247.49 355.9C238.474 365.044 226.653 372.065 212.34 376.91C198.476 381.601 182.116 384.206 163.745 384.719C145.773 385.201 125.832 383.647 104.357 380.173C98.4428 379.181 92.3126 378.086 86.3156 376.981C62.3274 372.559 37.504 368.051 21.0431 372.548C11.7151 375.074 5.01546 380.544 1.12833 388.824"
            nodeA={nodeSeptember20}
            nodeB={nodeJanuary21}
            nodeADirection={DIRECTION.TOP_LEFT}
            nodeBDirection={DIRECTION.TOP_RIGHT}
            containerOffset={{
              top: 72,
              right: 56.67,
              left: -174,
              bottom: 40.82,
            }}
          ></Line>
          <Line
            svgWidth={331}
            svgHeight={272}
            svgPathD="M325.055 271.695C330.926 256.923 331.89 244.165 327.86 233.707C327.672 233.044 327.416 232.474 327.161 231.904C319.352 214.487 297.198 203.936 263.062 201.372C235.954 199.331 203.45 201.141 171.998 202.853C127.394 205.294 81.2787 207.79 50.2147 199.366C33.7542 194.917 21.3217 187.23 13.1245 176.523C5.2278 166.243 1.2694 153.014 1.2064 137.229C1.1701 121.992 4.8914 104.138 12.1912 84.2425C19.2887 64.8735 30.0095 43.3205 43.8095 20.3243M324.826 271.674C330.629 256.995 331.593 244.235 327.586 233.829C320.525 215.392 298.115 204.272 262.811 201.548C235.795 199.465 203.291 201.275 171.839 202.987C127.234 205.428 81.1427 207.975 50.0554 199.5C33.5949 195.051 21.1392 187.311 12.942 176.605C5.022 166.273 1.0637 153.044 1.0007 137.259C0.941105 121.97 4.6624 104.115 11.9622 84.2205C19.1278 64.7595 29.7805 43.2985 43.5805 20.3025C47.427 13.971 51.5007 7.4132 55.5297 1"
            nodeA={nodeJanuary21}
            nodeB={nodeFebruary21}
            nodeADirection={DIRECTION.TOP_RIGHT}
            nodeBDirection={DIRECTION.TOP_LEFT}
            containerOffset={{
              top: 28,
              left: -99,
              right: 42.3,
              bottom: 93.7,
            }}
          ></Line>
          <Line
            svgWidth={847}
            svgHeight={289}
            svgPathD="M1 245.465C8.5554 254.003 16.214 260.525 23.6911 264.851C31.1669 269.265 38.3922 271.307 45.15 271.061C52.5544 270.826 59.2122 267.771 64.9065 261.983C70.8205 255.935 75.7005 247.065 79.2553 235.63C81.9017 227.163 83.9939 217.372 86.0087 207.931C89.1843 193.157 92.4398 177.858 97.7727 167.591C102.069 159.325 107.819 154.59 114.514 153.73C122.938 152.632 132.343 157.691 141.662 168.361C149.994 177.788 158.12 191.246 165.963 204.349C169.675 210.547 173.528 216.922 177.317 222.769C191.35 244.477 206.11 261.021 221.027 272.041C234.879 282.255 249.019 287.825 263.162 288.571C264.023 288.673 264.813 288.685 265.603 288.697C289.74 289.072 313.59 275.497 334.616 249.423C351.32 228.719 366.46 202.29 381.156 176.732C401.982 140.48 423.545 103.012 449.672 81.5778C463.501 70.2149 478.913 63.2621 495.549 60.8016C511.537 58.4188 528.825 60.2663 546.983 66.1621C564.498 71.8724 583.029 81.5455 602.007 94.8217C620.488 107.739 639.558 124.35 658.653 143.943C663.957 149.376 669.328 155.161 674.487 160.679C695.407 183.107 717.105 206.249 737.245 214.106C748.672 218.581 759.6 218.137 769.887 212.771C797.197 198.46 814.292 152.59 823.832 116.689C833.218 81.3994 840.104 40.5454 846.754 1.00335M1.21959 245.205C8.77635 253.655 16.3631 260.176 23.8402 264.503C31.3174 268.829 38.4708 270.87 45.2286 270.624C52.5612 270.387 59.1471 267.332 64.8401 261.632C70.7527 255.671 75.561 246.799 79.1157 235.365C81.7607 226.985 83.8529 217.194 85.8692 207.665C89.0447 192.891 92.3003 177.593 97.6331 167.325C101.929 159.06 107.824 154.24 114.591 153.38C123.087 152.284 132.563 157.431 141.882 168.101C150.142 177.527 158.266 191.073 166.181 204.177C169.893 210.375 173.746 216.75 177.535 222.597C191.568 244.305 206.256 260.847 221.173 271.868C234.955 281.993 249.095 287.563 263.166 288.308C288.078 289.66 312.718 276.097 334.549 249.158C351.251 228.543 366.391 202.114 381.087 176.555C401.913 140.303 423.404 102.834 449.603 81.4013C463.432 70.0384 478.916 63.0867 495.552 60.6262C511.612 58.2445 528.899 60.0921 547.058 65.9878C564.645 71.6992 583.176 81.3723 602.154 94.6485C620.705 107.655 639.704 124.177 658.799 143.77C664.032 149.202 669.404 154.899 674.634 160.506C695.553 182.934 717.252 206.076 737.32 213.931C748.675 218.406 759.603 217.961 769.818 212.594C797.055 198.37 814.077 152.586 823.616 116.685C833.002 81.3961 839.888 40.542 846.539 1"
            nodeA={nodeFebruary21}
            nodeB={nodeMarch21}
            nodeADirection={DIRECTION.BOTTOM_LEFT}
            nodeBDirection={DIRECTION.TOP_RIGHT}
            containerOffset={{
              top: -96,
              right: 102.75,
              bottom: 166.7,
              left: -296,
            }}
          ></Line>
          <Line
            svgWidth={366}
            svgHeight={204}
            svgPathD="M1 1.07481C2.55317 1.01742 4.10633 0.959991 5.81057 1.0378C33.6857 0.85244 62.2453 8.38484 90.9046 23.3751C121.77 39.5508 153.118 64.5782 183.777 97.9371C192.053 106.923 200.53 116.746 208.705 126.298C225.981 146.496 243.861 167.234 261.569 181.503C281.392 197.664 300.583 204.839 316.965 202.263C329.988 200.233 340.599 192.098 347.85 178.455C356.851 161.51 361.053 136.718 365.173 112.773M365.485 113.184C361.365 137.129 357.163 161.921 348.162 178.866C340.911 192.509 330.027 200.795 316.864 202.83C300.341 205.411 280.998 198.101 261.175 181.94C243.608 167.666 225.718 146.787 208.301 126.595C200.126 117.042 191.649 107.219 183.373 98.2336C152.714 64.8747 121.508 39.8421 90.6419 23.6663C62.1336 8.81131 33.5742 1.27893 5.8402 1.45907"
            nodeA={nodeMarch21}
            nodeB={nodeJuly21}
            nodeADirection={DIRECTION.RIGHT}
            nodeBDirection={DIRECTION.BOTTOM_RIGHT}
            containerOffset={{
              top: -31,
              left: -23,
              bottom: 149.34,
              right: 9.49,
            }}
          ></Line>

          <Line
            svgWidth={847}
            svgHeight={289}
            svgPathD="M1 245.465C8.5554 254.003 16.214 260.525 23.6911 264.851C31.1669 269.265 38.3922 271.307 45.15 271.061C52.5544 270.826 59.2122 267.771 64.9065 261.983C70.8205 255.935 75.7005 247.065 79.2553 235.63C81.9017 227.163 83.9939 217.372 86.0087 207.931C89.1843 193.157 92.4398 177.858 97.7727 167.591C102.069 159.325 107.819 154.59 114.514 153.73C122.938 152.632 132.343 157.691 141.662 168.361C149.994 177.788 158.12 191.246 165.963 204.349C169.675 210.547 173.528 216.922 177.317 222.769C191.35 244.477 206.11 261.021 221.027 272.041C234.879 282.255 249.019 287.825 263.162 288.571C264.023 288.673 264.813 288.685 265.603 288.697C289.74 289.072 313.59 275.497 334.616 249.423C351.32 228.719 366.46 202.29 381.156 176.732C401.982 140.48 423.545 103.012 449.672 81.5778C463.501 70.2149 478.913 63.2621 495.549 60.8016C511.537 58.4188 528.825 60.2663 546.983 66.1621C564.498 71.8724 583.029 81.5455 602.007 94.8217C620.488 107.739 639.558 124.35 658.653 143.943C663.957 149.376 669.328 155.161 674.487 160.679C695.407 183.107 717.105 206.249 737.245 214.106C748.672 218.581 759.6 218.137 769.887 212.771C797.197 198.46 814.292 152.59 823.832 116.689C833.218 81.3994 840.104 40.5454 846.754 1.00335M1.21959 245.205C8.77635 253.655 16.3631 260.176 23.8402 264.503C31.3174 268.829 38.4708 270.87 45.2286 270.624C52.5612 270.387 59.1471 267.332 64.8401 261.632C70.7527 255.671 75.561 246.799 79.1157 235.365C81.7607 226.985 83.8529 217.194 85.8692 207.665C89.0447 192.891 92.3003 177.593 97.6331 167.325C101.929 159.06 107.824 154.24 114.591 153.38C123.087 152.284 132.563 157.431 141.882 168.101C150.142 177.527 158.266 191.073 166.181 204.177C169.893 210.375 173.746 216.75 177.535 222.597C191.568 244.305 206.256 260.847 221.173 271.868C234.955 281.993 249.095 287.563 263.166 288.308C288.078 289.66 312.718 276.097 334.549 249.158C351.251 228.543 366.391 202.114 381.087 176.555C401.913 140.303 423.404 102.834 449.603 81.4013C463.432 70.0384 478.916 63.0867 495.552 60.6262C511.612 58.2445 528.899 60.0921 547.058 65.9878C564.645 71.6992 583.176 81.3723 602.154 94.6485C620.705 107.655 639.704 124.177 658.799 143.77C664.032 149.202 669.404 154.899 674.634 160.506C695.553 182.934 717.252 206.076 737.32 213.931C748.675 218.406 759.603 217.961 769.818 212.594C797.055 198.37 814.077 152.586 823.616 116.685C833.002 81.3961 839.888 40.542 846.539 1"
            nodeA={nodeJuly21}
            nodeB={nodeOctober21}
            nodeADirection={DIRECTION.BOTTOM_LEFT}
            nodeBDirection={DIRECTION.TOP_RIGHT}
            containerOffset={{
              top: -96,
              right: 102.75,
              bottom: 166.7,
              left: -296,
            }}
          ></Line>
          <Line
            svgWidth={366}
            svgHeight={204}
            svgPathD="M1 1.07481C2.55317 1.01742 4.10633 0.959991 5.81057 1.0378C33.6857 0.85244 62.2453 8.38484 90.9046 23.3751C121.77 39.5508 153.118 64.5782 183.777 97.9371C192.053 106.923 200.53 116.746 208.705 126.298C225.981 146.496 243.861 167.234 261.569 181.503C281.392 197.664 300.583 204.839 316.965 202.263C329.988 200.233 340.599 192.098 347.85 178.455C356.851 161.51 361.053 136.718 365.173 112.773M365.485 113.184C361.365 137.129 357.163 161.921 348.162 178.866C340.911 192.509 330.027 200.795 316.864 202.83C300.341 205.411 280.998 198.101 261.175 181.94C243.608 167.666 225.718 146.787 208.301 126.595C200.126 117.042 191.649 107.219 183.373 98.2336C152.714 64.8747 121.508 39.8421 90.6419 23.6663C62.1336 8.81131 33.5742 1.27893 5.8402 1.45907"
            nodeA={nodeOctober21}
            nodeB={nodeOctober22}
            nodeADirection={DIRECTION.BOTTOM_RIGHT}
            nodeBDirection={DIRECTION.TOP_LEFT}
            containerOffset={{
              top: -31,
              left: -23,
              bottom: 149.34,
              right: 9.49,
            }}
          ></Line>
          <Line
            svgWidth={543}
            svgHeight={237}
            svgPathD="M542.007 37.0693C534.223 28.7389 526.391 22.4264 518.8 18.3038C511.207 14.0934 503.929 12.2475 497.181 12.6759C489.785 13.1117 483.213 16.3447 477.677 22.2847C471.929 28.4902 467.29 37.4895 464.046 49.0163C461.629 57.5516 459.802 67.3957 458.043 76.8882C455.268 91.7424 452.428 107.124 447.374 117.532C443.303 125.911 437.684 130.799 431.014 131.84C422.623 133.165 413.084 128.363 403.48 117.948C394.897 108.75 386.41 95.5159 378.215 82.6296C374.337 76.5347 370.314 70.2661 366.368 64.5228C351.753 43.2028 336.552 27.0641 321.342 16.451C307.218 6.61486 292.933 1.42897 278.775 1.06546C277.912 0.987666 277.122 0.996806 276.331 1.00589C252.194 1.28332 228.719 15.4984 208.405 42.1314C192.267 63.2787 177.847 90.1071 163.847 116.054C144.009 152.856 123.467 190.893 97.9282 213.026C84.4122 224.758 69.1933 232.125 52.63 235.034C36.7122 237.848 19.3811 236.469 1.06975 231.066M541.794 37.3349C534.012 29.0922 526.251 22.7789 518.66 18.6562C511.069 14.5336 503.863 12.6868 497.114 13.1152C489.791 13.5502 483.29 16.7824 477.753 22.6346C472.003 28.7524 467.437 37.751 464.192 49.2778C461.775 57.7254 459.948 67.5695 458.19 77.1496C455.415 92.0039 452.574 107.386 447.521 117.793C443.45 126.172 437.688 131.15 430.946 132.192C422.483 133.517 412.871 128.628 403.268 118.214C394.756 109.015 386.268 95.693 378.002 82.8074C374.124 76.7126 370.1 70.444 366.154 64.7007C351.54 43.3806 336.41 27.2411 321.2 16.6281C307.15 6.87878 292.864 1.6929 278.778 1.32857C253.839 0.650426 229.574 14.8746 208.48 42.3937C192.341 63.4533 177.921 90.2817 163.921 116.229C144.083 153.03 123.613 191.067 98.0022 213.2C84.4861 224.933 69.1954 232.3 52.632 235.21C36.6424 238.025 19.3114 236.645 1 231.242"
            nodeA={nodeOctober22}
            nodeB={nodeMay23}
            nodeADirection={DIRECTION.TOP_LEFT}
            nodeBDirection={DIRECTION.TOP_RIGHT}
            containerOffset={{
              top: 66,
              right: 15.01,
              bottom: 70.63,
              left: -198,
            }}
          ></Line>
          <Line
            svgWidth={275}
            svgHeight={547}
            svgPathD="M107.331 546.732C83.8891 518.179 59.5791 488.77 40.5817 459.105C20.1094 427.201 7.00948 395.467 2.63794 367.32C0.523096 353.912 0.466361 341.612 2.4088 330.838C4.26429 320.013 8.23458 310.896 14.0578 303.673C20.4054 295.738 28.8948 290.323 39.2642 287.614C50.0692 284.821 62.783 284.865 76.9117 287.905C87.385 290.141 98.6966 293.782 109.602 297.296C126.686 302.771 144.349 308.475 158.804 308.869C170.443 309.184 179.827 305.776 186.201 298.993C194.233 290.468 197.053 277.148 194.307 260.527C191.964 245.735 185.504 228.729 179.158 212.245C176.159 204.446 173.102 196.387 170.509 188.715C160.855 160.275 156.855 134.165 158.393 111.225C159.839 89.9344 166.068 71.1398 177.021 55.2604C177.633 54.2604 178.274 53.391 178.915 52.5216C198.487 25.9656 231.477 8.1619 274.368 1M107.651 546.468C84.1508 517.994 59.8991 488.506 40.9886 458.892C20.545 427.119 7.44507 395.385 3.07354 367.237C1.04565 353.882 0.930714 341.661 2.87316 330.887C4.8156 320.113 8.72757 311.075 14.5508 303.852C20.8401 295.996 29.2713 290.66 39.5538 287.899C50.2719 285.055 62.9273 285.177 77.056 288.218C87.4424 290.402 98.7539 294.043 109.747 297.609C126.83 303.083 144.493 308.788 158.948 309.182C170.587 309.497 180.175 305.983 186.607 299.12C194.698 290.516 197.488 277.065 194.743 260.445C192.341 245.731 185.794 228.674 179.507 212.111C176.508 204.312 173.451 196.253 170.857 188.581C161.203 160.141 157.146 134.11 158.683 111.17C160.158 90.0101 166.387 71.2155 177.282 55.4151C196.538 27.4225 230.169 8.74938 274.57 1.23375"
            nodeA={nodeMay23}
            nodeB={nodeLast}
            nodeADirection={DIRECTION.RIGHT}
            nodeBDirection={DIRECTION.BOTTOM}
            containerOffset={{
              right: 160.57,
              top: 17,
            }}
            svgStyles={{
              transform: 'scaleX(-1)',
            }}
          ></Line>
        </>
      )}

      <AboutContainer>
        <AboutContentRow>
          <AboutTitle>
            About <br />
            Tip a ScRxipt
          </AboutTitle>
          <div></div>
          <div></div>
          <TimeLineItem
            offsetTop="-65px"
            maxWidth="448px"
            ref={nodeNovember19Ref}
            imageURL=""
            month="November"
            year="19"
            text="Tip a ScRxipt was inspired when Founder and CEO Chad Johnson’s mother lost her retiree insurance, was forced to apply for Medicare and her out of pocket expenses sky rocketed from less than $20/mo to over $400/mo for the same medication. "
          />
          <TimeLineItem
            offsetTop="-48px"
            maxWidth="368px"
            ref={nodeDecember19Ref}
            imageURL=""
            month="December"
            year="19"
            text="Chad and his mother attended a kick-off event in Milwaukee, WI for FOR-M - an initiative of the Milwaukee Tech Hub Coalition to support and grow Milwaukee's tech startup ecosystem."
          />
          <div></div>
          <div></div>
          <TimeLineItem
            offsetTop="-61px"
            maxWidth="280px"
            ref={nodeFebruary20Ref}
            imageURL={Ellipse5}
            month="February"
            year="20"
            text="Tip a ScRxipt was established as a company and local techies were hired to help with “techie stuff.”"
          />
          <TimeLineItem
            offsetTop="9px"
            maxWidth="297px"
            ref={nodeMay20Ref}
            imageURL=""
            month="May"
            year="20"
            text="Tip a ScRxipt was accepted into The Blueprint Accelerator program to validate and build out the idea."
          />
          <div></div>
          <div></div>
          <TimeLineItem
            offsetTop="-65px"
            maxWidth="296px"
            ref={nodeSeptember20Ref}
            imageURL=""
            month="September"
            year="20"
            text="Tip a ScRxipt won 2nd place in the Summerfest Tech Pitch Competition and a cash prize to work on building out the Tip a ScRxipt idea."
          />
          <AboutSubTitle offsetTop="-75px">
            Tip a ScRxipt was{' '}
            <span>listed as one of the 21 startups to watch in 2021</span> by
            Wisconsin Inno - Milwaukee Business Journal
          </AboutSubTitle>
          <div></div>

          <TimeLineItem
            offsetTop="65px"
            maxWidth="272px"
            ref={nodeJanuary21Ref}
            imageURL={Ellipse4}
            imgRef={nodeJanuary21ImgRef}
            month="January"
            year="21"
            text="Tip a ScRxipt was listed as one of the 21 startups to watch in 2021 by WIsconsin Inno - Milwaukee Business Journal."
          />
          <div></div>
          <div></div>
          <TimeLineItem
            offsetTop="-32px"
            maxWidth="291px"
            ref={nodeFebruary21Ref}
            imageURL=""
            month="February"
            year="21"
            text="Tip a ScRxipt Founder and CEO Chad Johnson was accepted into the Northwestern Mutual Black Founder Accelerator and received investment funds."
          />
          <TimeLineItem
            offsetTop="11px"
            maxWidth="296px"
            ref={nodeMarch21Ref}
            imageURL=""
            month="March"
            year="21"
            text="Tip a ScRxipt Founder and CEO Chad Johnson and his mother appeared on Project Pitch It (Milwaukee’s Shark Tank Style show on ABC) and won the first place Project Pitch It Award."
          />
          <div></div>
          <div></div>
          <TimeLineItem
            offsetTop="-33px"
            maxWidth="296px"
            ref={nodeJuly21Ref}
            imageURL={Ellipse6}
            month="July"
            year="21"
            text="Tip a ScRxipt launched its first debit card pilot to help selected participants cover their out of pocket prescription medication expenses."
          />
          <div></div>
          <div></div>
          <TimeLineItem
            offsetTop="9px"
            maxWidth="297px"
            ref={nodeOctober21Ref}
            imageURL=""
            month="October"
            year="21"
            text="Tip a ScRxipt closed its $500k seed round led by Milwaukee’s Gateway Capital, becoming the firm’s first investment."
          />
          <div></div>
          <div></div>
          <TimeLineItem
            offsetTop="9px"
            maxWidth="297px"
            ref={nodeOctober22Ref}
            imageURL=""
            month="October"
            year="22"
            text="Tip a ScRxipt went live with its first 7 customers with a customized Direct Primary Care (DPC) program in partnership with CU Ventures."
          />
          <div></div>
          <div></div>
          <TimeLineItem
            offsetTop="9px"
            maxWidth="297px"
            ref={nodeMay23Ref}
            imageURL=""
            month="May"
            year="23"
            text="Tip a ScRxipt partnered with American Family Insurance Institute of Corporate and Social Impact to launch a payment assistance program with Outreach Community Health Center."
          />
        </AboutContentRow>
      </AboutContainer>
      <AboutLaunchContainer ref={nodeLastRef}>
        <div>
          <AboutYear>
            20<span>24</span>
          </AboutYear>
        </div>
        <AboutLaunchTitle>
          Tip a ScRxipt is <span>launching new card programs </span> with
          Government, Health Related Foundations and Food is Medicine
          Organizations to improve health outcomes{' '}
        </AboutLaunchTitle>
      </AboutLaunchContainer>
    </>
  );
};
export default About;
